module.exports = __webpack_public_path__ + "img/earthtones-scheme.07c594d4.png";